module.exports = __webpack_public_path__ + "img/info-date.d182055c.svg";